import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { TooltipDirective } from '@cloudfactorydk/ng2-tooltip-directive';
import { MenuController, ModalController, ToastController } from '@ionic/angular';
import { map, shareReplay, Subject, takeUntil } from 'rxjs';
import { AlertModalComponent } from 'src/app/components/alert-modal/alert-modal.component';
import { EmmiterMessage, OutputMessage } from 'src/app/models/common/output.model';
import { ProductService, ProductType, ProductUI } from 'src/app/shared-lib/domains/product';
import { ProductHandle, productSelected$ } from 'src/app/shop/productos/handler/product-handler';
import { AppService } from '../../app.service';
import { CartService } from '../../cart.service';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  standalone: false
})
export default class ProductCardComponent extends ProductHandle implements OnInit, OnChanges, OnDestroy, EmmiterMessage {

  @ViewChild('card') card: ElementRef;
  @ViewChild('tooltip', { static: false }) tooltip: TooltipDirective;

  @Input() product: ProductUI;
  @Input() lateralList = false;
  @Input() smallLabels = false;
  @Input() context: string;
  @Output() action = new EventEmitter<OutputMessage>();
  @Output() updateOpenedCardProduct = new EventEmitter<any>();

  private componentDestroyed = new Subject();

  cartSteps: boolean = false;

  elementHover = false;
  optionsSelected = null;
  highestDiscount = 0;

  addedToCartConfirmation: boolean = false;

  constructor(
    public cartService: CartService,
    public modalController: ModalController,
    public toastController: ToastController,
    public productService: ProductService,
    private router: Router,
    public menuCtrl: MenuController,
    private appS: AppService
  ) {
    super();

  }

  ngOnInit(): void {
    this.product$ = this.productService.getProductWithVariants$(this.product.id).pipe(shareReplay(1));

    this.product$.pipe(
      map(product => {
        const variantId = this._variantSelected.value?.id;

        if (!product) return null;

        return variantId ? product.variants.find(variant => variant.id === variantId) : product.variants?.length ? product.variants[0] : null;
      }),
      takeUntil(this.componentDestroyed)
    ).subscribe(this._variantSelected);

    this.productSelected$ = productSelected$(this.product$, this._qty, this._variantSelected);

  }

  ngOnChanges(): void {
  }

  ngAfterViewInit() {
    this.appS.registerTooltip(this.tooltip);
  }

  ngOnDestroy() {
    this.appS.unregisterTooltip(this.tooltip);
  }

  onQtyChange(event) {
    this._qty.next(event.qty);
  }

  async onAdd(product: ProductUI) {
    if ((this.cartService.cart.items.some(it => it.product.presale) || product.presale) &&
      (this.cartService.cart.items.some(it => !it.product.presale && it.product.type !== ProductType.STORE) || (!product.presale && product.type !== ProductType.STORE))
    ) {
      const modal = await this.modalController.create({
        component: AlertModalComponent, // AddressComponent,
        componentProps: {
          msg: 'Con el fin de poder respetar los tiempos de entrega no es posible combinar bonos o impresiones junto a un producto en preventa, ya que este se encuentra en proceso de producción. Por favor realiza 2 pedidos independientes.'
        },
        cssClass: 'auto-height'
      });
      await modal.present();
      return;
    }
    this.cartService.setProductCart(product, this._qty.value);

    this.addedToCartConfirmation = true;
    await setTimeout(() => {
      this.addedToCartConfirmation = false;
    }, 5000);
  }

  onVariantChange(event) {
    this._variantSelected.next(event.variant);
  }

  onUpdateOptionsSelected(event) {
    this.optionsSelected = event;
  }

  public onAction(event: OutputMessage) {
    event.invoke(this);
  }

  emitAction(type: string, value?: any): void {
    this.action.emit(new OutputMessage(type, value));
  }

  setElementHover(status) {
    this.elementHover = status;
  }

  /**
   * It is necessary to know the context of the product card to avoid opening
   * the same card in all contexts, as it is the same card instance in different
   * contexts.
   * Therefore, this method updates in ProductService the opened product.
   * In case of custom products, the user is redirected to its page to customize
   * the product before being able to add it to the cart.
   * @param context
   * @returns
   */
  updateOpenedProduct(context: string) {

    if (this.product.isCustom || this.product.subType === 'custom' || this.product.customType === 'noteBook') {
      this.router.navigate(['/papeleria/catalogo', this.product.slug]);
      if (this.lateralList) {
        this.menuCtrl.close('cart-preview');
      }
      return;
    }

    this.productService.productOpened = { product: null, context: null };
    this.productService.productOpened = { product: this.product, context: context };
  }

  openCartSteps(context: string) {
    const { product, context: openContext } = this.productService.productOpened || { product: null, context: null };

    return product?.id === this.product.id && openContext === context;
  }

  close() {
    this.productService.productOpened = { product: null, context: null };
  }

}
